<script lang="ts" setup>
import NotFoundSvg from '~/assets/img/404-illustration.svg'

const { t } = useTranslation()

const homepageRoute = useHomepageRoute()
const productSearchRoute = useProductSearchRoute()
const prescriptionUploadRoute = usePrescriptionUploadRoute()
</script>

<template>
  <div
    class="mt-8 sm:mt-10"
    text="center"
  >
    <NotFoundSvg class="mx-auto lt-sm:h-35.5 lt-sm:w-fit" />
    <div
      flex="~ col gap-4"
      class="mt-8 sm:mt-10 sm:max-w-118.75 sm:mx-auto"
    >
      <IaHeading
        :level="2"
        font-700
      >
        {{ t('error.title') }}
      </IaHeading>
      <IaParagraph color="grey-600">
        {{ t('error.subtitle') }}
      </IaParagraph>
    </div>

    <div
      flex="~ col gap-4 sm:row sm:gap-8"
      class="w-full mx-auto mt-6 sm:mt-8 sm:w-fit"
    >
      <IaNuxtLink
        :to="homepageRoute"
        class="w-full"
      >
        <IaButton class="!lt-sm:w-full">
          {{ t('error.button.1') }}
        </IaButton>
      </IaNuxtLink>

      <IaNuxtLink
        :to="productSearchRoute"
        class="w-full"
      >
        <IaButton class="!lt-sm:w-full">
          {{ t('error.button.2') }}
        </IaButton>
      </IaNuxtLink>

      <IaNuxtLink
        :to="prescriptionUploadRoute"
        class="w-full"
      >
        <IaButton class="!lt-sm:w-full">
          {{ t('error.button.3') }}
        </IaButton>
      </IaNuxtLink>

      <IaNuxtLink
        :to="{ name: 'login' }"
        class="w-full"
      >
        <IaButton class="!lt-sm:w-full">
          {{ t('error.button.4') }}
        </IaButton>
      </IaNuxtLink>
    </div>
  </div>
</template>
